import { prompt, type PromptDefinition } from './models';

export const ASSET_MANAGER_PROMPTS = [
    prompt(
        'Keep it running',
        "What do condition reports say about this building's major assets?",
        'Which buildings have the poorest documented major-asset condition?'
    ),
    prompt(
        'Keep it running',
        'Which assets in this building have documented replacement recommendations?',
        'Which asset replacements across my buildings should be reviewed first?'
    ),
    prompt(
        'Keep it running',
        "What lifecycle information is available for this building's equipment?",
        'Which buildings have missing or outdated equipment lifecycle information?'
    ),
    prompt(
        'Keep it running',
        'Find asset condition assessments for this building covering…',
        'Find asset condition assessments across my buildings covering…',
        'prefill'
    ),
    prompt(
        'Keep it running',
        "What capital works are recommended in this building's available plans?",
        'Compare recommended capital works across my buildings.'
    ),
    prompt(
        'Keep it running',
        "Which assets drive recurring maintenance in this building's records?",
        'Which buildings have assets with the most recurring maintenance issues?'
    ),
    prompt(
        'Keep it running',
        "What evidence supports the priorities in this building's capital plan?",
        'Which buildings have capital priorities without supporting condition evidence?'
    ),
    prompt(
        'Keep it running',
        'Find replacement-cost estimates for this building relating to…',
        'Find replacement-cost estimates across my buildings relating to…',
        'prefill'
    ),
    prompt(
        'Keep it running',
        "Which warranties and service-life assumptions affect this building's replacement plans?",
        'Which buildings have replacement plans affected by expiring warranties or service-life assumptions?'
    ),
    prompt(
        'Improve performance',
        "What efficiency upgrades are recommended for this building's assets?",
        'Compare documented asset-efficiency upgrade opportunities across my buildings.'
    ),
    prompt(
        'Keep it running',
        "Where do this building's asset register and condition reports disagree?",
        'Which buildings have asset-register conflicts to resolve before investment planning?'
    ),
    prompt(
        'Keep it running',
        "Compare repair and replacement evidence for this building's…",
        'Compare repair and replacement evidence across my buildings for…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
